import React from "react";
import withLoadable from "../components/with-loadable";
import { useRoutes } from "react-router-dom";
import PublicLayout from "../layouts/PublicLayout";
import PrivateLayout from "../layouts/PrivateLayout";
import DashboardLayout from "../layouts/DashboardLayout";
import { Helmet } from "react-helmet";
import CourseReviews from "../pages/course/reviews";
import MyReview from "../pages/review/myReviews";

const DashboardPage = withLoadable(() => import("../pages/Dashboard"));
const LoginPage = withLoadable(() => import("../pages/Login"));
const ForgetPassword = withLoadable(() => import("../pages/password/forgetPassword"));
const OtpVerification = withLoadable(() => import("../pages/password/otpVerification"));
const SetPassword = withLoadable(() => import("../pages/password/createPassword"));
const ChangePassword = withLoadable(() => import("../pages/password/changePassword"));
const Course = withLoadable(() => import("../pages/course"));
const AddCourse = withLoadable(() => import("../pages/course/add"));
const UpdateCourse = withLoadable(() => import("../pages/course/update"));
const ViewCourse = withLoadable(() => import("../pages/course/view"));
const EnrollCourseUser = withLoadable(() => import("../pages/course/enrollUsers"));
const Test = withLoadable(() => import("../pages/test"));
const TestView = withLoadable(() => import("../pages/test/view"));
const TestAttemptedUser = withLoadable(() => import("../pages/test/attemptedUser"));
const CommunityForum = withLoadable(() => import("../pages/communityForum"));
const CommunityForumView = withLoadable(() => import("../pages/communityForum/view"));
const Blogs = withLoadable(() => import("../pages/blogs"));
const BlogView = withLoadable(() => import("../pages/blogs/view"));
const CourseReview = withLoadable(() => import("../pages/review/course"));
const EditProfile = withLoadable(() => import("../pages/settings/editProfile"));
const AboutUs = withLoadable(() => import("../pages/cms/aboutUs"));
const PrivacyPolicy = withLoadable(() => import("../pages/cms/privacyPolicy"));
const TermsCondition = withLoadable(() => import("../pages/cms/termCondition"));
const FAQ = withLoadable(() => import("../pages/cms/faq"));
const Chat = withLoadable(()=> import("../pages/chat"));

const RouterContainer = () => {
  const routes = [
    {
      path: "/",
      element: <PublicLayout />,
      children: [
        {
          path: "/",
          element: <LoginPage />,
        },
        {
          path: "/forget-password",
          element: <ForgetPassword />,
        },
        {
          path: "/otp-verification",
          element: <OtpVerification />,
        },
        {
          path: "/set-password",
          element: <SetPassword />,
        },
      ],
    },
    {
      path: "/",
      element: <PrivateLayout />,
      children: [
        {
          element: <DashboardLayout />,
          children: [
            {
              path: "/dashboard",
              element: <DashboardPage />,
            },
            {
              path: "/change-password",
              element: <ChangePassword />,
            },
            {
              path: "/course",
              element: <Course />,
            },
            {
              path: "/course/add",
              element: <AddCourse />,
            },
            {
              path: "/course/edit",
              element: <UpdateCourse />,
            },
            {
              path: "/course/view",
              element: <ViewCourse />,
            },
            {
              path: "/course/enroll-users",
              element: <EnrollCourseUser />,
            },
            {
              path: "/course/reviews",
              element: <CourseReviews />,
            },
            {
              path: "/test",
              element: <Test />,
            },
            {
              path: "/test/view",
              element: <TestView />,
            },
            {
              path: "/test/attempted-users",
              element: <TestAttemptedUser />,
            },
            {
              path: "/community-forum",
              element: <CommunityForum />,
            },
            {
              path: "/community-forum/view",
              element: <CommunityForumView />,
            },
            {
              path: "/blog",
              element: <Blogs />,
            },
            {
              path: "/blog/view",
              element: <BlogView />,
            },
            {
              path: "/review/course",
              element: <CourseReview />,
            },
            {
              path: "/review/my-reviews",
              element: <MyReview />,
            },
            {
              path: "/edit-profile",
              element: <EditProfile />,
            },
            {
              path: "/about",
              element: <AboutUs />,
            },
            {
              path: "/privacy-policy",
              element: <PrivacyPolicy />,
            },
            {
              path: "/terms-condition",
              element: <TermsCondition />,
            },
            {
              path: "/faq",
              element: <FAQ />,
            },
            {
              path: "/chat",
              element: <Chat />,
            },
          ],
        },
      ],
    },
  ];

  return (
    <>
      <Helmet>
        <script
          src={process.env.PUBLIC_URL + "/assets/js/app.js"}
          async
        ></script>
      </Helmet>
      {useRoutes(routes)}
    </>
  );
};

export default RouterContainer;
